
    const data = {"name":"src/core/icons/coffee","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M2 21h18v-2H2M20 8h-2V5h2m0-2H4v10a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-3h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            